module.exports = __webpack_public_path__ + "media/images/element/05-74d5ede1cc6b9dc7e15640aba67fab5a.png";